import LocationTileTutorialRefive from 'src/components/img/svg/tutorials/LocationTileTutorialRefive';
import Styles from 'src/components/Styles';
import NotificationTutorialIcon from '../../../img/svg/tutorials/NotificationTutorialIcon';
import {View} from 'react-native';

export function appTourScreenStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    titleText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.headerFont,
      color: Styles.white,
      marginBottom: Styles.Spacing.m1,
      textAlign: 'center',
    },
    descriptionText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '400',
      fontSize: Styles.Fonts.f7,
      color: Styles.white,
      textAlign: 'center',
      maxWidth: 220,
    },
    stepIndicatorText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.sectionHeader,
      color: Styles.white,
    },
    btnBottomViewText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
      textDecorationLine: 'underline',
    },
    nextBtnTextView: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
    },
    notificationIconView: {},
  };
}
export function appTourNotificationIcon(): JSX.Element {
  return (
    <View
      style={{
        width: 50,
        height: 50,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <NotificationTutorialIcon color={'white'} />
      <View
        style={{
          position: 'absolute',
          top: 7,
          right: 7,
          width: 14,
          height: 14,
          borderRadius: 7,
          backgroundColor: Styles.Colors.Aramark.carib,
        }}
      />
    </View>
  );
}
export function appTourLocationNotificationIcon(): JSX.Element {
  return <LocationTileTutorialRefive />;
}
export function skipBtnColor() {
  return Styles.Colors.PayNew.white01;
}
export default {
  appTourScreenStyles,
  appTourNotificationIcon,
  appTourLocationNotificationIcon,
  skipBtnColor,
};
